import classnames from 'classnames';
import React from 'react';
import { components } from 'react-select';

import { colors } from '../../../../utils/styles/defaultTheme';
import Divider from '../../../general/Divider';
import Icon from '../../../general/Icon';
import Text from '../../../typography/Text';
import Popover from '../../../utils/Popover';

const getHintContent = (hint, titleClassName) => {
    if (!hint) return null;
    if (typeof hint === 'string' || React.isValidElement(hint)) return hint;
    if (!hint.title && !hint.body) return null;

    return (
        <>
            {hint.title ? (
                <Text type="button" className={titleClassName}>
                    {hint.title}
                </Text>
            ) : null}
            {hint.body ? <Text>{hint.body}</Text> : null}
        </>
    );
};

const Option = React.memo(({ children, ...props }) => {
    const { isSelected, isDisabled } = props;
    const {
        className,
        override,
        optionFocusDisabledClassName,
        isSelectAllFocused,
        optionInnerClassName,
        optionLockIconClassName,
        optionHintTitleClassName,
    } = props.selectProps.optionProps;

    if (props?.data?.divider) {
        return <Divider />;
    }

    const hintContent = getHintContent(props.data?.hint, optionHintTitleClassName);
    const lockIcon = isDisabled ? (
        <span className={optionLockIconClassName} data-testid="select-option-lock">
            <Icon name="lock" size="medium" color={colors.grey[500]} />
        </span>
    ) : null;

    return (
        components.Option && (
            <components.Option
                {...props}
                className={classnames(className, {
                    [optionFocusDisabledClassName]: isSelectAllFocused && !isSelected,
                })}
                {...override.option}
            >
                <div className={optionInnerClassName}>
                    {children}
                    {hintContent ? (
                        <Popover content={hintContent} placement="top" trigger={['hover']}>
                            {lockIcon}
                        </Popover>
                    ) : (
                        lockIcon
                    )}
                </div>
            </components.Option>
        )
    );
});

Option.displayName = 'Option';

export default Option;
